var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "s-order-item"
  }, [_c('div', {
    staticClass: "s-order-item-image",
    class: _vm.order.is_original_org ? 's-bg-secondary' : 's-bg-warning',
    on: {
      "click": function click($event) {
        return _vm.showDetail();
      }
    }
  }, [_c('div', {
    staticClass: "s-order-item-image-wrapper"
  }, [_c('img', {
    attrs: {
      "src": _vm.image
    }
  })]), _c('p', {
    staticClass: "s-py-2 s-text-center"
  }, [_vm.order.is_original_org ? _c('img', {
    attrs: {
      "src": require("@/assets/images/liff/group-buying/poya.svg")
    }
  }) : _c('img', {
    attrs: {
      "src": require("@/assets/images/liff/group-buying/poya-home.svg")
    }
  })])]), _c('div', {
    staticClass: "s-order-item-info s-space-y-2 mt-2",
    on: {
      "click": function click($event) {
        return _vm.showDetail();
      }
    }
  }, [_c('p', {
    staticClass: "s-text-gray-darker s-text-xs s-whitespace-nowrap"
  }, [_vm._v(" 訂購日 : "), _vm.order ? _c('span', [_vm._v(_vm._s(_vm.createdDateTime))]) : _vm._e()]), _c('p', {
    staticClass: "s-text-gray-darker s-text-xs s-whitespace-nowrap"
  }, [_vm._v(" 訂單號 : "), _vm.order ? _c('span', [_vm._v(_vm._s(_vm.order.outer_order_number))]) : _vm._e()]), _vm.order ? _c('p', {
    staticClass: "s-text-gray-darker s-text-xs s-whitespace-nowrap"
  }, [_vm._v(" " + _vm._s(_vm.deliveryText) + " ")]) : _vm._e(), _c('p', {
    staticClass: "s-font-bold s-text-xs"
  }, [_c('span', {
    staticClass: "s-text-gray-darker s-mr-2"
  }, [_vm._v("共 " + _vm._s(_vm.quantity) + " 件")]), _c('span', {
    staticClass: "s-text-secondary"
  }, [_vm._v(_vm._s(_vm.$currency(_vm.order.total)))]), _c('span', {
    staticClass: "ml-2 s-orders-btn"
  }, [_vm._v("查看")])])]), _c('div', {
    staticClass: "s-order-item-tag s-flex-col s-justify-between"
  }, [_c('div', [_vm.order ? _c('a', {
    staticClass: "s-tag s-mt-auto s-tag-secondary"
  }, [_vm._v(_vm._s(_vm.order.status_label))]) : _vm._e()]), _vm.order.source_type === 3 && _vm.status === 'processing' ? _c('div', {
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.$refs.qrcode.open();
      }
    }
  }, [_c('img', {
    staticClass: "s-order-item-qrcode",
    attrs: {
      "src": require("@/assets/images/liff/group-buying/img-qrcode-mock.png"),
      "alt": "",
      "srcset": ""
    }
  })]) : _vm._e()]), _c('Modal', {
    ref: "qrcode",
    attrs: {
      "title": "",
      "noActions": "",
      "hasHeader": false
    }
  }, [[_c('div', {
    staticClass: "s-flex s-flex-center mb-3"
  }, [_c('qr-code', {
    attrs: {
      "text": _vm.order.outer_order_number
    }
  })], 1), _c('div', {
    staticClass: "s-flex s-space-x-3 s-flex-center m-2"
  }, [_c('div', {
    staticClass: "s-order-item-image",
    class: _vm.order.is_original_org ? 's-bg-secondary' : 's-bg-warning'
  }, [_c('div', {
    staticClass: "s-order-item-image-wrapper"
  }, [_c('img', {
    attrs: {
      "src": _vm.image
    }
  })]), _c('p', {
    staticClass: "s-py-2 s-text-center"
  }, [_vm.order.is_original_org ? _c('img', {
    attrs: {
      "src": require("@/assets/images/liff/group-buying/poya.svg")
    }
  }) : _c('img', {
    attrs: {
      "src": require("@/assets/images/liff/group-buying/poya-home.svg")
    }
  })])]), _c('div', {
    staticClass: "s-order-item-info s-space-y-2 mt-2 text-left ml-2"
  }, [_c('p', {
    staticClass: "s-text-gray-darker s-text-xs s-whitespace-nowrap"
  }, [_vm._v(" 訂購日 : "), _vm.order ? _c('span', [_vm._v(_vm._s(_vm.createdDateTime))]) : _vm._e()]), _c('p', {
    staticClass: "s-text-gray-darker s-text-xs s-whitespace-nowrap"
  }, [_vm._v(" 訂單號 : "), _vm.order ? _c('span', [_vm._v(_vm._s(_vm.order.outer_order_number))]) : _vm._e()]), _c('p', {
    staticClass: "s-font-bold s-text-xs"
  }, [_c('span', {
    staticClass: "s-text-gray-darker s-mr-2"
  }, [_vm._v("共 " + _vm._s(_vm.quantity) + " 件")]), _c('span', {
    staticClass: "s-text-secondary"
  }, [_vm._v(_vm._s(_vm.$currency(_vm.order.total)))])]), _c('p', {
    staticClass: "s-text-gray-darker s-text-xs s-whitespace-nowrap"
  }, [_vm._v(" " + _vm._s(_vm.deliveryText) + " ")])])])]], 2)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }